import React, { Component, createRef } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import Alert from '../../../components/Alert/Alert';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import IconCategoryIssueInfo from '../../../assets/icons/IconCategoryIssueInfo';
import IconCategoryIssueDelete from '../../../assets/icons/IconCategoryIssueDelete';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import API_ISSUE_CATEGORY from '../../../api/apiIssueCategory';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_ISSUE_CATEGORY_INSERT, SETTING_ISSUE_CATEGORY_VIEW } from '../../../constants/menuPermissionConstant';
import IssueCategoryMenu from '../../../components/Settings/IssueCategoryMenu';

class Complaint extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopupInfo: false,
            detailCategoryIssue: [],
            productOptions: {
                data: [],
                value: [],
            },
            moduleOptions: {
                data: [],
                value: [],
            },
            levelCSOptions: [],
            priorityOptions: [],
            showConfirmSaveAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            currentPage: 1,
            totalCategoryIssue: 0,
            totalCategoryIssueFromGetAPI: 0,
            disableButtonAddAndSave: true,
        }
        this.focusLastRef = createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        this.getProductList();
        this.getLevelCSList();
        this.getPriorityList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getProductList = () => {
        API_ISSUE_CATEGORY.getProductList(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempProducts = getContent(res).map(productDetail => ({
                        value: productDetail.id,
                        label: productDetail.complaint_description
                    }));
                    this.setState({ productOptions: { ...this.state.productOptions, data: tempProducts } });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getModuleList = complaintId => {
        API_ISSUE_CATEGORY.getModuleList(complaintId, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempModules = getContent(res).map(moduleDetail => ({
                        value: moduleDetail.id,
                        label: moduleDetail.complaint_category
                    }));
                    this.setState({ moduleOptions: { ...this.state.moduleOptions, data: tempModules } });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getInitiateCategoryIssueList = complaintCategoryId => {
        API_ISSUE_CATEGORY.getInitiateCategoryIssueList(complaintCategoryId, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ totalCategoryIssue: getContent(res).count_data })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getCategoryIssueList = (complaintCategoryId, currentPage) => {
        API_ISSUE_CATEGORY.getCategoryIssueList(complaintCategoryId, currentPage, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempCategoryIssue = getContent(res).map((categoryIssueDetail, index) => ({
                        id: categoryIssueDetail.id,
                        complaintCategoryId: categoryIssueDetail.complaint_category_id,
                        complaintSub: categoryIssueDetail.complaint_sub,
                        complaintSubAlias: categoryIssueDetail.complaint_sub_alias,
                        level: categoryIssueDetail.level,
                        priority: categoryIssueDetail.priority,
                        reportMapping: categoryIssueDetail.report_mapping,
                        pointScore: categoryIssueDetail.point_score,
                        penaltyScore: categoryIssueDetail.penalty_score,
                        action: categoryIssueDetail.action,
                        targetResolutionTime: categoryIssueDetail.target_resolution_time,
                        createdAt: categoryIssueDetail.created_at,
                        createdBy: categoryIssueDetail.created_by,
                        updatedBy: categoryIssueDetail.updated_by,
                        updatedAt: categoryIssueDetail.updated_at,
                        categoryIssueIndex: this.state.detailCategoryIssue.length + index,
                        showAlertPenalty: false,
                        showAlertPoint: false,
                        showAlertPointMinimal: false,
                        showAlertPenaltyMinimal: false,
                    }));
                    let concatCategoryIssue = this.state.detailCategoryIssue.concat(tempCategoryIssue);
                    this.setState({ detailCategoryIssue: concatCategoryIssue, totalCategoryIssueFromGetAPI: this.state.totalCategoryIssueFromGetAPI + tempCategoryIssue.length, disableButtonAddAndSave: false });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getLevelCSList = () => {
        API_ISSUE_CATEGORY.getLevelCSList(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempLevelCS = getContent(res).map(levelDetail => ({
                        value: levelDetail.remark,
                        label: levelDetail.description.slice(-1)
                    }));
                    this.setState({ levelCSOptions: tempLevelCS });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getPriorityList = () => {
        API_ISSUE_CATEGORY.getPriorityList(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempPriority = getContent(res).map(priorityDetail => ({
                        value: priorityDetail.remark,
                        label: priorityDetail.description
                    }));
                    this.setState({ priorityOptions: tempPriority });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleChangeProduct = e => {
        this.setState(
            {
                detailCategoryIssue: [],
                productOptions: { ...this.state.productOptions, value: e },
                moduleOptions: {
                    ...this.state.moduleOptions,
                    data: [],
                    value: [],
                },
                currentPage: 1,
                totalCategoryIssue: 0,
                totalCategoryIssueFromGetAPI: 0,
                disableButtonAddAndSave: true,
            },
            () => this.getModuleList(e.value)
        );
    }

    handleChangeModule = e => {
        this.setState({
            detailCategoryIssue: [],
            moduleOptions: { ...this.state.moduleOptions, value: e },
            currentPage: 1,
            totalCategoryIssue: 0,
            totalCategoryIssueFromGetAPI: 0,
            disableButtonAddAndSave: true,
        },
            () => {
                this.getInitiateCategoryIssueList(e.value);
                this.getCategoryIssueList(e.value, this.state.currentPage);
            }
        );
    }

    handleAddCategoryIssue = () => {
        const categoryIssueObject = {
            id: 0,
            complaintCategoryId: this.state.moduleOptions.value.length !== 0 ? this.state.moduleOptions.value.value : null,
            complaintSub: "",
            complaintSubAlias: "",
            level: "",
            priority: "",
            reportMapping: "",
            pointScore: 0,
            penaltyScore: 0,
            action: 1,
            targetResolutionTime: "0",
            createdAt: "",
            createdBy: 0,
            updatedBy: 0,
            updatedAt: "",
            showAlertPoint: false,
            showAlertPenalty: false,
            showAlertPointMinimal: false,
            categoryIssueIndex: this.state.detailCategoryIssue.length,
        }
        this.state.detailCategoryIssue.splice(this.state.detailCategoryIssue.length, 0, categoryIssueObject);
        this.setState({
            detailCategoryIssue: this.state.detailCategoryIssue
        },
            () => {
                this.focusLastRef.current.scrollIntoView({ behavior: 'smooth' })
            }
        );
    }

    handleDeleteCategoryIssue = (data, dataIndex) => {
        // Action 0 = Data Default from BE
        // Action 1 = New Data
        // Action 2 = Edited Date
        // Action 3 = Deleted Data  
        if (data.action === 0 || data.action === 2) {
            this.setState({ showConfirmDeleteAlert: false });
            return this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], action: 3 }) : obj)
                )
            }));
        }
        this.state.detailCategoryIssue.splice(dataIndex, 1);
        this.setState({ detailCategoryIssue: this.state.detailCategoryIssue, showConfirmDeleteAlert: false });
    }

    handleChange = (event, data, dataIndex) => {
        // Show Alert Error for Point and Penalty Score
        if (event.target.value <= 999 && event.target.name === "pointScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPoint: false }) : obj)
                )
            }));
        }
        if (event.target.value <= 999 && event.target.name === "penaltyScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPenalty: false }) : obj)
                )
            }));
        }
        if (event.target.value > 0 && event.target.name === "pointScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPointMinimal: false }) : obj)
                )
            }));
        }
        if (event.target.value >= 0 && event.target.name === "penaltyScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPenaltyMinimal: false }) : obj)
                )
            }));
        }
        if (event.target.value <= 0 && event.target.name === "pointScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPointMinimal: true }) : obj)
                )
            }));
        }
        if (event.target.value < 0 && event.target.name === "penaltyScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPenaltyMinimal: true }) : obj)
                )
            }));
        }
        if (event.target.value > 999 && event.target.name === "pointScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPoint: true }) : obj)
                )
            }));
        }
        if (event.target.value > 999 && event.target.name === "penaltyScore") {
            this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], showAlertPenalty: true }) : obj)
                )
            }));
        }

        // Set Text Field by Action
        if (data.action === 0) {
            return this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], [event.target.name]: event.target.value, action: 2 }) : obj)
                )
            }));
        }
        this.setState(prevState => ({
            detailCategoryIssue: prevState.detailCategoryIssue.map(
                obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], [event.target.name]: event.target.value }) : obj)
            )
        }));
    }

    handleChangeLevel = (event, data, dataIndex) => {
        if (data.action === 0) {
            return this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], level: event.value, action: 2 }) : obj)
                )
            }));
        }
        this.setState(prevState => ({
            detailCategoryIssue: prevState.detailCategoryIssue.map(
                obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], level: event.value }) : obj)
            )
        }));
    }

    handleChangePriority = (event, data, dataIndex) => {
        if (data.action === 0) {
            return this.setState(prevState => ({
                detailCategoryIssue: prevState.detailCategoryIssue.map(
                    obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], priority: event.value, action: 2 }) : obj)
                )
            }));
        }
        this.setState(prevState => ({
            detailCategoryIssue: prevState.detailCategoryIssue.map(
                obj => (obj.categoryIssueIndex === (data.categoryIssueIndex) ? Object.assign(obj, { ...this.state.detailCategoryIssue[dataIndex], priority: event.value }) : obj)
            )
        }));
    }

    handleSaveCategoryIssue = () => {
        this.setState({ showConfirmSaveAlert: false });
        for (const data of this.state.detailCategoryIssue) {
            if (data.pointScore <= 0 ||
                data.pointScore > 999) {
                this.setState({
                    errorMessage: "Poin Minimal 1 & Maksimal 999",
                    showErrorAlertResponse: true
                })
                return
            }

            if (data.penaltyScore < 0 ||
                data.penaltyScore > 999) {
                return this.setState({
                    errorMessage: "Penalti Minimal 1 & Maksimal 999",
                    showErrorAlertResponse: true
                })

            }
        }

        const data = this.state.detailCategoryIssue.map((data) => {
            return {
                id: data.id,
                complaint_sub: data.complaintSub,
                complaint_sub_alias: data.complaintSubAlias,
                report_mapping: data.reportMapping,
                complaint_category_id: data.complaintCategoryId,
                target_resolution_time: data.targetResolutionTime,
                priority: data.priority,
                level: data.level,
                point_score: parseInt(data.pointScore),
                penalty_score: parseInt(data.penaltyScore),
                created_at: data.createdAt,
                created_by: data.createdBy,
                updated_by: data.updatedBy,
                updated_at: data.updatedAt,
                action: data.action
            }
        })

        const wrapDataToCategoryIssue = { category_issues: data };
        API_ISSUE_CATEGORY.postCategoryIssue(wrapDataToCategoryIssue, this.props.token)
            .then(res => {
                this.setState({
                    detailCategoryIssue: [],
                    showConfirmSaveAlert: false,
                    showSuccessAlert: true,
                    currentPage: 1,
                    totalCategoryIssue: 0,
                    totalCategoryIssueFromGetAPI: 0,
                },
                    () => {
                        this.getInitiateCategoryIssueList(this.state.moduleOptions.value.value);
                        this.getCategoryIssueList(this.state.moduleOptions.value.value, this.state.currentPage);
                    }
                )
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleCancel = () => {
        this.setState(
            {
                detailCategoryIssue: [],
                productOptions: {
                    ...this.state.productOptions,
                    value: [],
                },
                moduleOptions: {
                    ...this.state.moduleOptions,
                    data: [],
                    value: [],
                },
                currentPage: 1,
                totalCategoryIssue: 0,
                totalCategoryIssueFromGetAPI: 0,
                disableButtonAddAndSave: true,
            }
        );
    }

    handleLoadMore = () => {
        this.setState(prevState => ({
            currentPage: prevState.currentPage + 1
        }),
            () => {
                this.getCategoryIssueList(this.state.moduleOptions.value.value, this.state.currentPage);
            }
        );
    }

    showAlertDataChange = () => {
        let showAlert = false;
        for (let index in this.state.detailCategoryIssue) {
            if (this.state.detailCategoryIssue[index].action !== 0) {
                showAlert = true;
                break;
            }
        }
        return showAlert;
    }

    checkLastTwoRow = valueIndex => {
        if (valueIndex === this.state.detailCategoryIssue.length - 1 ||
            valueIndex === this.state.detailCategoryIssue.length - 2
        ) {
            return true;
        }
        return false;
    }

    dataLengthActionNotEqualThree = value => {
        if (value.action !== 3) {
            return value
        }
    }

    truncateFunction = value => {
        let maxLength = 40;
        if (!value) {
            return
        }
        if (value.length <= maxLength) {
            return value
        }
        return value.substring(0, maxLength) + "..."
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* BREADCRUMBS */}
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="Kategori Masalah"
                        title="Kategori Masalah"
                    />

                    {/* WHITECONTAINER */}
                    <div className="h-content relative">
                        <div className="calculate-layout-ticket bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* MENU */}
                            <IssueCategoryMenu />

                            {/* FILTER PRODUCT & MODULE */}
                            <div className="space-y-4">
                                <div className="w-1/4 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Produk</p>
                                    </div>
                                    <Select
                                        inputId="ddsproduct"
                                        name="product"
                                        options={this.state.productOptions.data}
                                        value={this.state.productOptions.value}
                                        placeholder="Pilih Produk"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        maxMenuHeight={170}
                                        onChange={this.handleChangeProduct}
                                    />
                                </div>

                                <div className="space-y-4">
                                    <div className="w-1/4 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Modul</p>
                                        </div>
                                        <Select
                                            inputId="ddsmodul"
                                            name="module"
                                            options={this.state.moduleOptions.data}
                                            value={this.state.moduleOptions.value}
                                            placeholder="Pilih Modul"
                                            components={{ IndicatorSeparator: () => null }}
                                            className="w-full"
                                            maxMenuHeight={170}
                                            onChange={this.handleChangeModule}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* CONTENT */}
                            <div className="space-y-6">
                                {/* HEADER CONTENT */}
                                <div className="flex justify-between items-center">
                                    <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddcomplaint" onClick={this.handleAddCategoryIssue} className={`flex items-center text-white py-2 px-6 rounded-md ${this.state.disableButtonAddAndSave ? "bg-gray-500 cursor-default" : "bg-olddarkblue cursor-pointer"}`} disabled={this.state.disableButtonAddAndSave}>
                                            <IconAddTransparent />
                                            <span className="ml-2">Kategori</span>
                                        </button>
                                    </CheckPermissionComponent>
                                    <div className="flex justify-between items-center">
                                        <div className={`${this.showAlertDataChange() ? "mr-1" : "hidden"}`}>
                                            <span className="text-darkred">Anda telah merubah data kategori Issue. Silakan klik tombol Simpan untuk menyimpan perubahan tersebut.</span>
                                        </div>
                                        <div className="flex justify-center items-center relative">
                                            <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                                <IconCategoryIssueInfo />
                                            </div>
                                            <div className={this.state.showPopupInfo ? "absolute w-max top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                                <div className="italic">
                                                    <p className="font-bold">Note :</p>
                                                    <p>Kategori keluhan Customer adalah kategori keluhan yang akan muncul di Nexcare Mobile.</p>
                                                    <p>Level CS adalah level dari CS Officer yang akan handle kategori keluhan.</p>
                                                    <p>Prioritas adalah prioritas dari tiket dengan kategori keluhan.</p>
                                                    <p>Report Mapping adalah issue kategori di laporan bulanan.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-10">
                                        </div>
                                    </div>
                                </div>

                                {/* DETAIL CATEGORY ISSUE */}
                                <div className="space-y-5 overflow-y-auto h-72 p-1">
                                    {this.state.detailCategoryIssue.length > 0 ?
                                        <>
                                            {
                                                this.state.detailCategoryIssue.map((data, index, detailCategoryIssue) =>
                                                    <div key={`detail-category-issue-${index}`}
                                                        className={`
                                                            flex w-full
                                                            ${detailCategoryIssue[index].action === 3 && "hidden"}
                                                            ${(detailCategoryIssue[index].showAlertPoint || detailCategoryIssue[index].showAlertPenalty || detailCategoryIssue[index].showAlertPointMinimal || detailCategoryIssue[index].showAlertPenaltyMinimal) && "pb-5"}
                                                        `}>
                                                        <div className="flex w-full justify-between items-center space-x-5">
                                                            <div className="w-4/12">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Kategori Keluhan</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <input
                                                                    id="tslcategory"
                                                                    type="text"
                                                                    name="complaintSub"
                                                                    className="form-control-second w-full"
                                                                    placeholder="Kategori Keluhan"
                                                                    defaultValue={data.complaintSub}
                                                                    onChange={(e) => this.handleChange(e, data, index)}
                                                                />
                                                            </div>
                                                            <div className="w-4/12">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Kategori Keluhan Distributor</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <input
                                                                    id="tslcategorydistributor"
                                                                    type="text"
                                                                    name="complaintSubAlias"
                                                                    className="form-control-second w-full"
                                                                    placeholder="Tulis Kategori Keluhan Distributor"
                                                                    defaultValue={data.complaintSubAlias}
                                                                    onChange={(e) => this.handleChange(e, data, index)}
                                                                />
                                                            </div>
                                                            <div className="w-36">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Level CS</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <Select
                                                                    inputId="ddlcslevel"
                                                                    name="level"
                                                                    menuPlacement={this.state.detailCategoryIssue.filter(this.dataLengthActionNotEqualThree).length <= 3 ? "bottom" : this.checkLastTwoRow(index) ? "top" : "bottom"}
                                                                    value={this.state.levelCSOptions.find(levelValue => levelValue.value === data.level)}
                                                                    options={this.state.levelCSOptions}
                                                                    placeholder="1"
                                                                    components={{ IndicatorSeparator: () => null }}
                                                                    className="w-full"
                                                                    maxMenuHeight={170}
                                                                    onChange={(e) => this.handleChangeLevel(e, data, index)}
                                                                />
                                                            </div>
                                                            <div className="w-2/12">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Prioritas</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <Select
                                                                    inputId="ddlpriority"
                                                                    name="priority"
                                                                    menuPlacement={this.state.detailCategoryIssue.filter(this.dataLengthActionNotEqualThree).length <= 3 ? "bottom" : this.checkLastTwoRow(index) ? "top" : "bottom"}
                                                                    value={this.state.priorityOptions.find(priorityValue => priorityValue.value === data.priority)}
                                                                    options={this.state.priorityOptions}
                                                                    placeholder="Normal"
                                                                    components={{ IndicatorSeparator: () => null }}
                                                                    className="w-full"
                                                                    maxMenuHeight={170}
                                                                    onChange={(e) => this.handleChangePriority(e, data, index)}
                                                                />
                                                            </div>
                                                            <div className="w-4/12">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Report Mapping</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <input
                                                                    id="tslreportmapping"
                                                                    type="text"
                                                                    name="reportMapping"
                                                                    className="form-control-second w-full"
                                                                    placeholder="Tulis Report Mapping"
                                                                    defaultValue={data.reportMapping}
                                                                    onChange={(e) => this.handleChange(e, data, index)}
                                                                />
                                                            </div>
                                                            <div className="w-1/12 relative">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Poin</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <input
                                                                    id="tslpoint"
                                                                    type="number"
                                                                    onInput={(e) => e.target.value = +e.target.value.slice(0, 3)}
                                                                    name="pointScore"
                                                                    className="form-control-second w-full"
                                                                    placeholder="1"
                                                                    min={1}
                                                                    max={999}
                                                                    defaultValue={data.pointScore}
                                                                    onChange={(e) => this.handleChange(e, data, index)}
                                                                />
                                                                <div className={`absolute -bottom-5 ${!detailCategoryIssue[index].showAlertPointMinimal && "hidden"}`}>
                                                                    <MasterDataUserAlert text="Minimal 1" />
                                                                </div>
                                                                <div className={`absolute -bottom-10 ${!detailCategoryIssue[index].showAlertPoint && "hidden"}`}>
                                                                    <MasterDataUserAlert text="Maksimal 999" />
                                                                </div>
                                                            </div>
                                                            <div className="w-1/12 relative">
                                                                <div className="flex font-bold">
                                                                    <p className="mr-1">Penalti</p>
                                                                    <span className="text-darkred">*</span>
                                                                </div>
                                                                <input
                                                                    id="tslpenalty"
                                                                    type="number"
                                                                    name="penaltyScore"
                                                                    onInput={(e) => e.target.value = +e.target.value.slice(0, 3)}
                                                                    className="form-control-second w-full"
                                                                    placeholder="1"
                                                                    min={0}
                                                                    max={999}
                                                                    defaultValue={data.penaltyScore}
                                                                    onChange={(e) => this.handleChange(e, data, index)}
                                                                />
                                                                <div className={`absolute -bottom-5 ${!detailCategoryIssue[index].showAlertPenaltyMinimal && "hidden"}`}>
                                                                    <MasterDataUserAlert text="Minimal 0" />
                                                                </div>
                                                                <div className={`absolute -bottom-10 ${!detailCategoryIssue[index].showAlertPenalty && "hidden"}`}>
                                                                    <MasterDataUserAlert text="Maksimal 999" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flex justify-center mt-8 w-10">
                                                            <div id="btndelete" onClick={() => this.setState({ showConfirmDeleteAlert: true, seletedDeletedData: data, seletedDeletedDataIndex: index })} className="cursor-pointer">
                                                                <IconCategoryIssueDelete />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <div ref={this.focusLastRef}>
                                            </div>
                                        </>
                                        :
                                        <div>
                                            <br />
                                        </div>
                                    }
                                    {/* <div className={this.state.totalCategoryIssueFromGetAPI < this.state.totalCategoryIssue ? "flex justify-center" : "hidden"}>
                                        <button type="button" id="btnmore" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-1" onClick={() => this.handleLoadMore()}>Tampilkan Lebih Banyak</button>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                        <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_INSERT]} userPermission={this.props.userDetail.permissions}>
                            {/* Button */}
                            <div className="flex justify-end space-x-5 absolute bottom-0 right-0">
                                <button id="btncancel" className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={this.handleCancel}>Batal</button>
                                <button id="btnsave" className={`text-white py-2 px-6 rounded-lg font-medium ${this.state.disableButtonAddAndSave ? "bg-gray-500 cursor-default" : "bg-olddarkblue cursor-pointer"}`}
                                    onClick={() => this.setState({ showConfirmSaveAlert: true })}
                                    disabled={this.state.disableButtonAddAndSave ? true : false}
                                >
                                    Simpan
                                </button>
                            </div>
                        </CheckPermissionComponent>
                    </div>

                    <Alert show={this.state.showConfirmSaveAlert} button={true} title="Simpan Kategori Masalah?" desc={"Apakah Anda yakin ingin menyimpan data?"} close={() => this.setState({ showConfirmSaveAlert: false })} submit={() => this.handleSaveCategoryIssue()} />
                    <Alert show={this.state.showConfirmDeleteAlert} button={true} title="Hapus Kategori Masalah?" desc={`Apakah Anda yakin ingin menghapus kategori keluhan ${this.truncateFunction(this.state.seletedDeletedData?.complaintSub)}?`} close={() => this.setState({ showConfirmDeleteAlert: false, seletedDeletedData: null, seletedDeletedDataIndex: null })} submit={() => this.handleDeleteCategoryIssue(this.state.seletedDeletedData, this.state.seletedDeletedDataIndex)} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil di Simpan"} close={() => this.setState({ showSuccessAlert: false })} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Complaint);